module.exports = __webpack_public_path__ + "img/1473723729.1c92a6b2.jpg";